require('./bootstrap');
require('./modules/fag');
require('./modules/upload-photo');
require('./modules/auth/register');
require('./modules/admin/sidebar');
require('./modules/admin/clipboard');
require('./main');
require('./modules/admin/ajax/change-status');
require('./modules/admin/ajax/voting-process');
require('./modules/main/user-application');
require('./modules/main/ajax/user-voting');

require('@fancyapps/fancybox');

